import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  codigoUsuario: 0,
  bearerToken: "",
  name: "",
  email: "",
  situacao: 0
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.bearerToken = action.payload.Content.BearerToken;
      state.codigoUsuario = action.payload.Content.CodigoResponsavel || action.payload.Id;
      state.name = action.payload.Content.Nome;
      state.situacao = action.payload.Content.Situacao;
      localStorage.removeItem('firstLoadDone');
    },
    setEmail: (state, action) => {
      state.email = action.payload.Email;
    },
    loginCadastro: (state, action) => {
      state.isAuthenticated = true;
      state.bearerToken = action.payload.Content.Token;
      state.codigoUsuario = action.payload.Content.Id;
      state.name = action.payload.Content.Nome;
      state.situacao = 0;
    },
    solicitarHomolog: (state) => {
      state.situacao = 1;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.name = "";
      state.email = "";
      state.bearerToken = "";
      state.codigoUsuario = 0;
      localStorage.removeItem('firstLoadDone');
    },
  },
});

export const { logout, login, loginCadastro, setEmail, solicitarHomolog } = userSlice.actions;
export default userSlice.reducer;
